(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boss-launch-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('boss-launch-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const shownKey = 'boss-launch-popup-seen-v1';
  const successKey = 'boss-launch-popup-success-v1';
  const accessKey = 'boss-up-bling-subscriber';
  const success = dialog.querySelector('[data-launch-success]');
  const popupImage = dialog.querySelector('[data-launch-image]');
  let imageReady = !popupImage;
  let previousFocus;

  const loadPopupImage = () => {
    if (!popupImage || popupImage.dataset.loading) return;
    popupImage.dataset.loading = 'true';
    popupImage.addEventListener('load', () => {
      imageReady = true;
      popupImage.classList.add('is-ready');
    }, { once: true });
    popupImage.addEventListener('error', () => {
      popupImage.closest('.launch-image-panel')?.setAttribute('hidden', '');
    }, { once: true });
    popupImage.src = popupImage.dataset.src;
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadPopupImage, { timeout: 500 });
  } else {
    setTimeout(loadPopupImage, 300);
  }

  dialog.querySelectorAll('[data-launch-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => previousFocus?.focus?.());

  if (success) {
    try {
      localStorage.setItem(accessKey, '1');
      if (localStorage.getItem(successKey)) return;
      localStorage.setItem(successKey, '1');
    } catch { return; }
    loadPopupImage();
    if (imageReady) {
      previousFocus = document.activeElement;
      dialog.showModal();
    } else {
      popupImage?.addEventListener('load', () => {
        previousFocus = document.activeElement;
        dialog.showModal();
      }, { once: true });
    }
    return;
  }

  try { if (localStorage.getItem(shownKey)) return; } catch { return; }
  setTimeout(() => {
    if (!imageReady) return;
    if (document.hidden || document.querySelector('.offcanvas.show,.modal.show,dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    try { localStorage.setItem(shownKey, '1'); } catch {}
  }, 8000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["boss-style-finder-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('boss-style-finder');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const launch = document.getElementById('boss-launch-popup');
  const dismissKey = 'boss-launch-dismissed-session-v1';
  const seenKey = 'boss-style-finder-seen-v1';
  const accessKey = 'boss-up-bling-subscriber';
  const interestKey = 'boss-style-finder-interest';
  const success = dialog.querySelector('[data-style-success]');
  const form = dialog.querySelector('.style-form');
  const tags = dialog.querySelector('#BossStyleTags');
  const email = dialog.querySelector('#BossStyleEmail');
  const skip = dialog.querySelector('[data-style-skip]');
  let timer;
  let exitReady = false;
  let previousFocus;

  const hasAccess = () => {
    try { return localStorage.getItem(accessKey) === '1'; } catch { return true; }
  };

  const wasSeen = () => {
    try { return sessionStorage.getItem(seenKey) === '1'; } catch { return true; }
  };

  const markSeen = () => {
    try { sessionStorage.setItem(seenKey, '1'); } catch {}
  };

  const canOpen = () => {
    if (hasAccess() || wasSeen() || document.hidden) return false;
    if (launch?.open || document.querySelector('.offcanvas.show,.modal.show,dialog[open]')) return false;
    if (document.activeElement?.matches('input,textarea,select')) return false;
    return true;
  };

  const openFinder = () => {
    if (!canOpen()) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    markSeen();
  };

  const schedule = () => {
    clearTimeout(timer);
    exitReady = false;
    setTimeout(() => { exitReady = true; }, 15000);
    timer = setTimeout(openFinder, 45000);
  };

  const rememberDismissal = () => {
    if (hasAccess()) return;
    try { sessionStorage.setItem(dismissKey, '1'); } catch { return; }
    schedule();
  };

  launch?.addEventListener('close', rememberDismissal);
  try {
    if (sessionStorage.getItem(dismissKey) === '1') {
      const views = Number(sessionStorage.getItem('boss-style-page-views') || 0) + 1;
      sessionStorage.setItem('boss-style-page-views', String(views));
      if (views >= 3) setTimeout(openFinder, 1200);
      else schedule();
    }
  } catch {}

  document.addEventListener('mouseout', event => {
    if (!exitReady || event.clientY > 0 || event.relatedTarget) return;
    openFinder();
  });

  dialog.querySelectorAll('[data-style-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => previousFocus?.focus?.());

  dialog.querySelectorAll('[data-style-choice]').forEach(button => {
    button.addEventListener('click', () => {
      dialog.querySelectorAll('[data-style-choice]').forEach(choice => choice.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      const interest = button.dataset.styleChoice;
      const url = button.dataset.styleUrl;
      try { sessionStorage.setItem(interestKey, url); } catch {}
      if (tags) tags.value = `newsletter, heart-edit-offer, style-finder, interest-${interest}`;
      if (skip) skip.href = url;
      form?.classList.add('is-visible');
      email?.focus();
    });
  });

  if (success) {
    try { localStorage.setItem(accessKey, '1'); } catch {}
    previousFocus = document.activeElement;
    dialog.showModal();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["boss-up-bundle-pairing"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.buInitialized === 'true') return;
      root.dataset.buInitialized = 'true';

      const button = root.querySelector('[data-bu-add-pair]');
      const pairVariant = root.querySelector('[data-bu-pair-variant]');
      const pairPrice = root.querySelector('[data-bu-pair-price]');
      const status = root.querySelector('[data-bu-pair-status]');
      const productArea = root.closest('[data-section], .product, .product__info-container') || document;
      const productForm = root.closest('form[action*="/cart/add"]') || productArea.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (!button || !pairVariant || !productForm) return;

      if (pairVariant.tagName === 'SELECT' && pairPrice) {
        pairVariant.addEventListener('change', () => {
          pairPrice.textContent = pairVariant.selectedOptions[0]?.dataset.price || '';
        });
      }

      const collectProperties = () => {
        const properties = {};
        const formData = new FormData(productForm);
        formData.forEach((value, key) => {
          if (!key.startsWith('properties[') || value === '') return;
          properties[key.slice(11, -1)] = value;
        });
        properties._Boss_Up_offer = root.dataset.addonOnly === 'true' ? 'Featured add-on' : 'Stack & Save 15%';
        return properties;
      };

      button.addEventListener('click', async () => {
        const currentVariantInput = productForm.querySelector('[name="id"]');
        const quantityInput = productForm.querySelector('[name="quantity"]');
        const currentVariantId = Number(currentVariantInput?.value);
        const pairedVariantId = Number(pairVariant.value);
        if (!currentVariantId || !pairedVariantId) {
          status.textContent = root.dataset.addError;
          return;
        }

        const items = [
          {
            id: currentVariantId,
            quantity: Math.max(1, Number(quantityInput?.value) || 1),
            properties: collectProperties()
          },
          {
            id: pairedVariantId,
            quantity: 1,
            properties: {
              _Boss_Up_offer: root.dataset.addonOnly === 'true' ? 'Featured add-on' : 'Stack & Save 15%'
            }
          }
        ];

        button.disabled = true;
        status.textContent = root.dataset.adding;

        try {
          const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || root.dataset.addError);
          window.location.assign(root.dataset.cartUrl || '/cart');
        } catch (error) {
          button.disabled = false;
          status.textContent = error.message || root.dataset.addError;
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-bu-pairing]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-swatch-toggle]');
    if (!toggle) return;

    var container = toggle.closest('.swatches_container');
    if (!container) return;

    var hiddenSwatches = container.querySelectorAll('.swatch--extra');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    hiddenSwatches.forEach(function(swatch) {
      swatch.classList.toggle('swatch--hidden', isExpanded);
    });

    toggle.setAttribute('aria-expanded', String(!isExpanded));

    if (isExpanded) {
      var totalWithSwatch = hiddenSwatches.length + container.querySelectorAll('.swatch:not(.swatch--extra)').length;
      var maxVisible = totalWithSwatch - hiddenSwatches.length;
      var extraCount = totalWithSwatch - maxVisible;
      toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.34944 3.88805H9.47744V5.13605H5.34944V9.26405H4.10144V5.13605H-0.00256243V3.88805H4.10144V4.64916e-05H5.34944V3.88805Z" fill="currentcolor"/></svg>' + "<span></span>" +extraCount;
    } else {
      toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="2" viewBox="0 0 9 2" fill="none"><path d="M8.11456 -1.50204e-05V1.24799H0.00256252V-1.50204e-05H8.11456Z" fill="currentcolor"/></svg>';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-gift-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BossUpFreeGiftPickerInitialized) return;
    window.BossUpFreeGiftPickerInitialized = true;

    const pickerSelector = '[data-boss-free-gift]';
    const giftProperty = '_boss_up_free_gift';
    const giftHandle = 'life-of-the-party';
    const giftCode = 'PARTYFREE';
    const accessKey = 'boss-up-bling-subscriber';
    const applyingKey = 'boss-up-partyfree-applying';
    const STACK_MSG = 'Stack & Save is already taking money off your pieces, so the free ring isn’t available on this order. One offer per order — you’re getting the bigger saving.';

    const url = new URL(window.location.href);
    if (url.searchParams.get('bling_access') === '1') {
      try { localStorage.setItem(accessKey, '1'); } catch {}
      url.searchParams.delete('bling_access');
      window.history.replaceState({}, '', url);
    }

    const hasSubscriberAccess = picker => {
      if (picker.dataset.subscriber === 'true') return true;
      try { return localStorage.getItem(accessKey) === '1'; } catch { return false; }
    };

    const getPickers = () => Array.from(document.querySelectorAll(pickerSelector));

    const formatMoney = cents => {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    };

    const isGiftLine = item => item.handle === giftHandle && (item.properties?.[giftProperty] === 'true' || Number(item.final_line_price) === 0);

    const getState = (picker, cart) => {
      const threshold = Number(picker.dataset.threshold || 9900);
      const allocTitles = [];
      cart.items.forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => { if (allocation.amount > 0) allocTitles.push(String(allocation.discount_application.title || '').toLowerCase()); }));
      (cart.cart_level_discount_applications || []).forEach(app => allocTitles.push(String(app.title || '').toLowerCase()));
      const applied = allocTitles.some(title => title.includes('partyfree') || title.includes('life of the party'));
      const stackSave = allocTitles.some(title => title.includes('stack & save') || title.includes('stack &amp; save'));
      const giftInCart = cart.items.some(item => item.handle === giftHandle && item.properties?.[giftProperty] === 'true');
      const qualifyingSubtotal = cart.items.filter(item => !(item.handle === giftHandle && item.properties?.[giftProperty] === 'true')).reduce((sum, item) => sum + Number(item.final_line_price), 0);
      return { threshold, applied, stackSave, giftInCart, qualifyingSubtotal, qualifies: qualifyingSubtotal >= threshold };
    };

    const render = (picker, state) => {
      const status = picker.querySelector('[data-boss-free-gift-status]');
      const chooser = picker.querySelector('[data-boss-free-gift-chooser]');
      if (!hasSubscriberAccess(picker)) {
        picker.hidden = true;
        return;
      }
      picker.hidden = false;

      if (state.applied) {
        status.textContent = picker.dataset.added;
        chooser.hidden = true;
        return;
      }

      if (state.stackSave) {
        status.textContent = STACK_MSG;
        chooser.hidden = true;
        return;
      }

      if (state.qualifies) {
        status.textContent = picker.dataset.earned;
        chooser.hidden = state.giftInCart || !picker.querySelector('.boss-free-gift__card');
        return;
      }

      status.textContent = picker.dataset.away.replace('[amount]', formatMoney(Math.max(0, state.threshold - state.qualifyingSubtotal)));
      chooser.hidden = true;
    };

    const refresh = async () => {
      const pickers = getPickers();
      if (!pickers.length) return;

      pickers.filter(picker => !hasSubscriberAccess(picker)).forEach(picker => { picker.hidden = true; });
      const accessiblePickers = pickers.filter(hasSubscriberAccess);
      if (!accessiblePickers.length) return;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
        const cart = await response.json();
        if (!cart.items.length) {
          accessiblePickers.forEach(picker => { picker.hidden = true; });
          return;
        }

        const state = getState(accessiblePickers[0], cart);
        if (state.applied) {
          try { sessionStorage.removeItem(applyingKey); } catch {}
        }
        if (state.qualifies && state.giftInCart && !state.applied && !state.stackSave && window.location.pathname === window.Shopify.routes.root + 'cart') {
          let applying = false;
          try {
            applying = sessionStorage.getItem(applyingKey) === '1';
            if (!applying) sessionStorage.setItem(applyingKey, '1');
          } catch {}
          if (!applying) {
            window.location.assign(window.Shopify.routes.root + 'discount/' + giftCode + '?redirect=%2Fcart');
            return;
          }
        }
        accessiblePickers.forEach(picker => render(picker, state));
      } catch {
        accessiblePickers.forEach(picker => { picker.hidden = true; });
      }
    };

    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-boss-gift-add]');
      if (!button) return;

      const picker = button.closest(pickerSelector);
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = picker.dataset.adding;

      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
        const cart = await cartResponse.json();
        const state = getState(picker, cart);
        if (!state.qualifies || state.applied || state.stackSave || state.giftInCart) {
          await refresh();
          return;
        }

        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(button.dataset.variantId),
              quantity: 1,
              properties: { [giftProperty]: 'true' }
            }]
          })
        });

        if (!addResponse.ok) throw new Error('Gift add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        const back = window.location.pathname === window.Shopify.routes.root + 'cart' ? '%2Fcart' : encodeURIComponent(window.location.pathname + window.location.search);
        try { sessionStorage.setItem(applyingKey, '1'); } catch {}
        window.location.assign(window.Shopify.routes.root + 'discount/' + giftCode + '?redirect=' + back);
      } catch {
        const status = picker.querySelector('[data-boss-free-gift-status]');
        if (status) status.textContent = picker.dataset.error;
      } finally {
        button.disabled = false;
        button.textContent = originalText;
      }
    });

    document.addEventListener('cart:refresh', () => setTimeout(refresh, 200));
    document.addEventListener('DOMContentLoaded', refresh);
    if (document.readyState !== 'loading') refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
